<div class="row_1">
	<label class="label tab-heading titlered">Dashboard</label>
	<button class="primarybutton" style="float: right;" *ngIf="false" (click)="AddToQueue();">Add To
		Queue</button>

	<div class="top_grid_agg">
		<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
		</app-notification-message>
		<label class="groupI"> Group I </label>
		<app-periods-dropdown periodLabel="Planning Period" (eventHandler)="componentEventHandler($event);"
			style="float: right;margin-top: 1%;margin-right: 2%;">
		</app-periods-dropdown>

		<div class="fullHeaderGraphs">
			<img src="./assets/images/refresh_button.svg" class="refresh-button" (click)="loadData()" />
			<label class="summary"> Summary </label>
			<img src="./assets/images/baseline-keyboard_arrow_right-24px.png" *ngIf="openCard" class="upArrow"
				(click)="closeCardClick()" />
			<img src="./assets/images/baseline-keyboard_arrow_right-down-24px.png" *ngIf="!openCard" class="downArrow"
				(click)="openCardClick()" />
		</div>

		<div class="topCard row" *ngIf="openCard">
			<div class="block1 col-5">
				<label class="perCompleteHeader"> %Evaluation Complete by Domicile in current Tier/Round </label>

				<!-- pie chart comes here  -->
				<div class="chart skeleton h-75" *ngIf="pieChartLoading"></div>
				<div class="chart pie-chart-flex-container" *ngIf="isPieChartData && !pieChartLoading">
					<div class="chart-canvas">
						<canvas baseChart [data]="{ labels: pieChartLabels, datasets: pieChartData }"
							[type]="pieChartType" [options]="pieChartOptions" [plugins]="pieChartPlugins">
						</canvas>
					</div>
				</div>

				
				<div *ngIf="!isPieChartData && !pieChartLoading" class="chart pie-chart-flex-container">

					<canvas baseChart [data]="{ labels: nodataLabels, datasets: [{ data: nodata,backgroundColor: nodatacolor[0].backgroundColor}] }"
						[type]="pieChartType" [options]="nodataOptions" [plugins]="pieChartPlugins"></canvas>

				</div>
			</div>

			<div class="block2 col-5">
				<label class="dailyTarget"> Daily Target </label>
				<div class="row skeleton h-75" *ngIf="barChartLoading"></div>
				<div class="row" *ngIf="!barChartLoading">
					<!-- bar chart comes here -->
					<div style="display: block; width: 380px; height: 250px;" class="col-8">

						<canvas baseChart [data]="{ labels: barChartLabels, datasets: barChartData }"
							[type]="barChartType" [options]="barChartOptions" [plugins]="barChartPlugins">
						</canvas>

					</div>
					<!-- [legend]="barChartLegend" -->
					<div class="dailyTarWords col-3">
						<div>
							<span class="plannedTotalData"> {{totalComplete}}% </span>
						</div>
						<div>
							<label class="plannedTotalLabel"> Planned Total </label>
						</div>
						<div>
							<span class="actualTotalData"> {{LLTComplete}}% </span>
						</div>
						<div>
							<label class="actualTotalLabel"> Actual Total </label>
						</div>
					</div>
				</div>
			</div>

			<!-- three tiles come here -->
			<div class="block3 col-1">
				<div class="sectionbase skeleton" *ngIf="tilesValueLoading"></div>
				<div class="sectionbase" *ngIf="!tilesValueLoading">
					<span class="totalData"> {{tile_one_TC}}% </span>
					<br>
					<span class="totalLabel"> Total Evaluation </span>
				</div>
				<div class="sectionbase sectionSpacing skeleton" *ngIf="tilesValueLoading"></div>
				<div class="sectionbase sectionSpacing" *ngIf="!tilesValueLoading">
					<span class="LLTData"> {{tile_two_LLTC}}% </span>
					<br>
					<span class="LLTLabel"> LLT Evaluation </span>
				</div>
				<div class="sectionbase sectionSpacing skeleton" *ngIf="tilesValueLoading"></div>
				<div class="sectionbase sectionSpacing" *ngIf="!tilesValueLoading">
					<span class="contData"> {{tile_three_CC}}% </span>
					<br>
					<span class="contLabel"> Contingency Evaluation </span>
				</div>
			</div>
		</div>

		<div class="grid-agg">
			<label class="tiers"> Tiers </label>
			<ag-grid-angular #agGrid style="width: 100%; height: 400px;" id="tiers-table" class="ag-theme-balham" [theme]="'legacy'"
				[pagination]="setPagination" [columnDefs]="columnDefs" [rowData]="rowData"
				[defaultColDef]="defaultColDef" [paginationPageSize]="rowCount" (gridReady)="onGridReady($event)"
				(gridSizeChanged)="onGridSizeChanged($event)" [icons]="icons" [getRowStyle]="getRowStyle"
				[context]="context" [gridOptions]="gridOptions" [modules]="modules"
				[overlayLoadingTemplate]="overlayLoadingTemplate">
			</ag-grid-angular>

			<div class="row col-12" style="bottom: 24px; position: relative; padding-left :13px">
				<div class="w-25 col-4 ">
					<div>
						<label class="page-drpdwn-label">Records / Page: </label>&nbsp;
						<select class="page-drpdwn" (change)="onPageSizeChanged($event)">
							<option value="5">5</option>
							<option value="10">10</option>
							<option value="20">20</option>
							<option value="50">50</option>
							<option value="ALL" selected>ALL</option>
						</select>

					</div>
				</div>

				<div style="display: flex;" class="pagination_text col-4 offset-2">
					<mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToFirstPage()"
						[ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
						first_page</mat-icon>
					<mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToPreviousPage()"
						[ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
						keyboard_arrow_left</mat-icon>
					<p class="total_row_text">Total Row {{rowCount}}</p>
					<mat-icon style="cursor: pointer; margin-top: -4px;"
						[ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
						(click)="goToNexpage()">keyboard_arrow_right
					</mat-icon>
					<mat-icon style="cursor: pointer; margin-top: -4px;"
						[ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
						(click)="goToLastPage()">last_page
					</mat-icon>
				</div>
			</div>
		</div>
	</div>
</div>